import { z } from 'zod/v4';

import type { VehicleStatus } from '@klareospace/pharos-lib-types';
import { VEHICLE_STATUS } from '@klareospace/pharos-lib-types';

// ─── Messages ─────────────────────────────────────────────────────────────────

export interface VehicleSchemaMessages {
  carrierRequired: string;
  licensePlateRequired: string;
  spaceRequired: string;
  vehicleTemplateRequired: string;
}

// ─── Constants ────────────────────────────────────────────────────────────────

export const VEHICLE_STATUS_VALUES = Object.values(VEHICLE_STATUS) as [VehicleStatus, ...VehicleStatus[]];

// ─── Factory ──────────────────────────────────────────────────────────────────

export function createVehicleSchema(messages: VehicleSchemaMessages): z.ZodObject<{
  carrierId: z.ZodString;
  defaultDriverId: z.ZodOptional<z.ZodString>;
  licensePlate: z.ZodString;
  siteIds: z.ZodArray<z.ZodString>;
  spaceId: z.ZodString;
  status: z.ZodEnum<Record<VehicleStatus, VehicleStatus>>;
  vehicleTemplateId: z.ZodString;
}> {
  return z.object({
    carrierId: z.string().trim().min(1, messages.carrierRequired),
    defaultDriverId: z.string().optional(),
    licensePlate: z.string().trim().min(1, messages.licensePlateRequired),
    siteIds: z.array(z.string()),
    spaceId: z.string().trim().min(1, messages.spaceRequired),
    status: z.enum(VEHICLE_STATUS_VALUES),
    vehicleTemplateId: z.string().trim().min(1, messages.vehicleTemplateRequired),
  });
}

export type VehicleFormInput = z.infer<ReturnType<typeof createVehicleSchema>>;
